import { all, takeLatest } from 'redux-saga/effects';
import {
  FETCH_PVS_REQUEST,
  CREATE_PVS_REQUEST,
  UPDATE_PVS_REQUEST,
  DELETE_PVS_REQUEST,
  FETCH_PVS_DETAILS_REQUEST,
  FETCH_PVS_CATEGORY_REQUEST,
  CREATE_PVS_CATEGORY_REQUEST,
  UPDATE_PVS_CATEGORY_REQUEST,
  FETCH_PVS_CATEGORY_DETAILS_REQUEST,
  FETCH_PVS_SUBCATEGORY_REQUEST,
  CREATE_PVS_SUBCATEGORY_REQUEST,
  UPDATE_PVS_SUBCATEGORY_REQUEST,
  FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST,
  FETCH_PVS_KEYWORD_REQUEST,
  CREATE_PVS_KEYWORD_REQUEST,
  UPDATE_PVS_KEYWORD_REQUEST,
  FETCH_PVS_KEYWORD_DETAILS_REQUEST,
  FETCH_PVS_BRAND_REQUEST,
  ALL_BAZAAR_LIST_REQUEST,
  FETCH_STALL_LIST_REQUEST,
  GET_BOOKING_LIST_REQUEST,
  SUBMIT_BOOKING_REQUEST,
  FETCH_BOOKING_DETAILS_REQUEST,
  ADD_BOOKING_PAYMENT_REQUEST,
  RESEND_INVOICE_REQUEST,
  GET_USER_BILLING_INFO_REQUEST,
  REGENERATE_INVOICE_REQUEST,
  DOWNLOAD_INVOICES_REQUEST,
  DOWNLOAD_BOOKING_REPORT_REQUEST,
  DOWNLOAD_BALANCE_REPORT_REQUEST,
  GET_PVS_DETAILS_REQUEST,
  FETCH_KEYWORDS_REQUEST,
  UPDATE_PVS_REGISTRATION_REQUEST,
  VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST,
  GET_BAZAAR_STALL_DETAILS_REQUEST,
  UPDATE_BAZAAR_STALL_DETAILS_REQUEST,
  ADD_BAZAAR_REQUEST,
  ADD_BAZAAR_STALL_DETAILS_REQUEST,
  CANCEL_STALL_BOOKING_REQUEST,
  GET_PAYMENT_STATISTICS_REQUEST,
  FETCH_PRODUCTS_REQUEST,
  CREATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_REQUEST,
  DELETE_PRODUCT_REQUEST,
  FETCH_PRODUCT_DETAILS_REQUEST,
} from '../../types/pvs';
import {
  fetchPvsWorker,
  createPvsWorker,
  updatePvsWorker,
  deletePvsWorker,
  fetchPvsDetailsWorker,
  fetchPvsCategoryWorker,
  createPvsCategoryWorker,
  updatePvsCategoryWorker,
  fetchPvsCategoryDetailsWorker,
  fetchPvsSubcategoryWorker,
  createPvsSubcategoryWorker,
  updatePvsSubcategoryWorker,
  fetchPvsSubcategoryDetailsWorker,
  fetchPvsKeywordWorker,
  createPvsKeywordWorker,
  updatePvsKeywordWorker,
  fetchPvsKeywordDetailsWorker,
  fetchPvsBrandWorker,
  getBazaarListWorker,
  fetchStallListWorker,
  getBookingListWorker,
  submitBookingWorker,
  addBookingPaymentWorker,
  fetchBookingDetailsWorker,
  resendInvoiceWorker,
  getUserBillingInfoWorker,
  regenerateInvoiceWorker,
  downloadInvoicesWorker,
  downloadBookingReportWorker,
  downloadBalanceReportWorker,
  getPvsDetailsWorker,
  updatePvsRegistrationWorker,
  fetchKeywordsWorker,
  verifyPvsRegistrationWorker,
  getBazaarStallDetailsWorker,
  updateBazaarStallDetailsWorker,
  addBazaarWorker,
  addBazaarStallDetailsWorker,
  cancelStallBookingWorker,
  getPaymentStatisticsWorker,
  fetchProductsWorker,
  createProductWorker,
  updateProductWorker,
  deleteProductWorker,
  fetchProductDetailsWorker,
} from '../workers/pvsWorker';

export default function* pvsWatcher() {
  yield all([
    takeLatest(FETCH_KEYWORDS_REQUEST, fetchKeywordsWorker),
    takeLatest(UPDATE_PVS_REGISTRATION_REQUEST, updatePvsRegistrationWorker),
    takeLatest(VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST, verifyPvsRegistrationWorker),

    takeLatest(FETCH_PVS_REQUEST, fetchPvsWorker),
    takeLatest(CREATE_PVS_REQUEST, createPvsWorker),
    takeLatest(UPDATE_PVS_REQUEST, updatePvsWorker),
    takeLatest(DELETE_PVS_REQUEST, deletePvsWorker),
    takeLatest(FETCH_PVS_CATEGORY_REQUEST, fetchPvsCategoryWorker),
    takeLatest(CREATE_PVS_CATEGORY_REQUEST, createPvsCategoryWorker),
    takeLatest(UPDATE_PVS_CATEGORY_REQUEST, updatePvsCategoryWorker),
    takeLatest(FETCH_PVS_CATEGORY_DETAILS_REQUEST, fetchPvsCategoryDetailsWorker),
    takeLatest(FETCH_PVS_SUBCATEGORY_REQUEST, fetchPvsSubcategoryWorker),
    takeLatest(CREATE_PVS_SUBCATEGORY_REQUEST, createPvsSubcategoryWorker),
    takeLatest(UPDATE_PVS_SUBCATEGORY_REQUEST, updatePvsSubcategoryWorker),
    takeLatest(FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST, fetchPvsSubcategoryDetailsWorker),
    takeLatest(FETCH_PVS_KEYWORD_REQUEST, fetchPvsKeywordWorker),
    takeLatest(CREATE_PVS_KEYWORD_REQUEST, createPvsKeywordWorker),
    takeLatest(UPDATE_PVS_KEYWORD_REQUEST, updatePvsKeywordWorker),
    takeLatest(FETCH_PVS_KEYWORD_DETAILS_REQUEST, fetchPvsKeywordDetailsWorker),
    takeLatest(FETCH_PVS_BRAND_REQUEST, fetchPvsBrandWorker),
    takeLatest(ALL_BAZAAR_LIST_REQUEST, getBazaarListWorker),
    takeLatest(FETCH_STALL_LIST_REQUEST, fetchStallListWorker),
    takeLatest(FETCH_PVS_DETAILS_REQUEST, fetchPvsDetailsWorker),
    takeLatest(GET_BOOKING_LIST_REQUEST, getBookingListWorker),
    takeLatest(SUBMIT_BOOKING_REQUEST, submitBookingWorker),
    takeLatest(FETCH_BOOKING_DETAILS_REQUEST, fetchBookingDetailsWorker),
    takeLatest(ADD_BOOKING_PAYMENT_REQUEST, addBookingPaymentWorker),
    takeLatest(RESEND_INVOICE_REQUEST, resendInvoiceWorker),
    takeLatest(GET_USER_BILLING_INFO_REQUEST, getUserBillingInfoWorker),
    takeLatest(REGENERATE_INVOICE_REQUEST, regenerateInvoiceWorker),
    takeLatest(DOWNLOAD_INVOICES_REQUEST, downloadInvoicesWorker),
    takeLatest(DOWNLOAD_BOOKING_REPORT_REQUEST, downloadBookingReportWorker),
    takeLatest(DOWNLOAD_BALANCE_REPORT_REQUEST, downloadBalanceReportWorker),
    takeLatest(GET_PVS_DETAILS_REQUEST, getPvsDetailsWorker),
    takeLatest(GET_BAZAAR_STALL_DETAILS_REQUEST, getBazaarStallDetailsWorker),
    takeLatest(UPDATE_BAZAAR_STALL_DETAILS_REQUEST, updateBazaarStallDetailsWorker),
    takeLatest(ADD_BAZAAR_STALL_DETAILS_REQUEST, addBazaarStallDetailsWorker),
    takeLatest(ADD_BAZAAR_REQUEST, addBazaarWorker),
    takeLatest(CANCEL_STALL_BOOKING_REQUEST, cancelStallBookingWorker),
    takeLatest(GET_PAYMENT_STATISTICS_REQUEST, getPaymentStatisticsWorker),
    
    // Product watchers
    takeLatest(FETCH_PRODUCTS_REQUEST, fetchProductsWorker),
    takeLatest(CREATE_PRODUCT_REQUEST, createProductWorker),
    takeLatest(UPDATE_PRODUCT_REQUEST, updateProductWorker),
    takeLatest(DELETE_PRODUCT_REQUEST, deleteProductWorker),
    takeLatest(FETCH_PRODUCT_DETAILS_REQUEST, fetchProductDetailsWorker),
  ]);
}
